<template>
    <div class="studentList">
        <div class="search_container searchArea">
            <el-form :inline="true" :model='searchForm' ref="searchForm" class="demo-form-inline search-form">
                <el-form-item label="单位">
                    <el-select v-model="searchForm.schoolId" filterable placeholder="请选择">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="行政班" >
                    <el-select v-model="searchForm.hardClassId" filterable placeholder="请选择">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in hardClassList" :key="item.id" :label="item.name+'('+item.year+')'" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属专业"  >
                    <el-select v-model="searchForm.professionId" filterable placeholder="请选择">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in professionList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="查找">
                    <el-input v-model="searchForm.searchText" placeholder="工号、账号、姓名或学科"  @keyup.enter.native='loadStudentList'></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" size ="mini" icon="search" @click='loadStudentList'>查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size ="mini" icon="search" @click='openStudent(null)'>添加</el-button>

                </el-form-item>
                <el-form-item>
                    <jsonExcel class="export-excel-wrapper" :data="jsonData" :fields="jsonFields" :beforeGenerate="excelOutput" name="学生信息.xls">
                        <el-button type="warning" size ="mini" :loading="jsonLoading" >导出</el-button>
                    </jsonExcel>
                </el-form-item>
<!--              <el-form-item>-->
<!--                <el-button type="danger" size ="mini" icon="search" @click='delSelectionStudent(null)'>批量删除</el-button>-->
<!--              </el-form-item>-->

            </el-form>
        </div>
        <div class="table_container">
            <el-table v-loading="loading" :data="tableData" @selection-change="selectionChange"  style="width: 100%" align='center'>
<!--                <el-table-column type="selection" width="50"></el-table-column>-->
                <el-table-column prop="my_no" label="学号"  width="150" align='center' ></el-table-column>
                <el-table-column prop="name" label="用户名"  width="150" align='center' ></el-table-column>
                <el-table-column prop="nick_name" label="姓名"  width="150" align='center' ></el-table-column>
                <el-table-column prop="school_name" label="所属单位" align='center' ></el-table-column>
                <el-table-column prop="hard_class_name" label="行政班" align='center' ></el-table-column>
                <el-table-column prop="year" label="入学年" align='center' ></el-table-column>
                <el-table-column prop="profession_name" label="专业" align='center' ></el-table-column>
                <el-table-column prop="phone_no" label="联系方式" align='center' ></el-table-column>
                <el-table-column prop="remark" label="备注" align='center' ></el-table-column>
                <el-table-column prop="operation" align='center' label="操作" width="300">
                    <template slot-scope='scope'>
                        <el-button icon='edit' size="mini" @click='openStudent(scope.row)'>编辑</el-button>
                        <el-button type="danger" icon='edit' size="mini" @click='onDeleteStudent(scope.row)'>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination  :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
        </div>
        <studentDialog ref="studentDialog" :student="selStudent" @ok="loadStudentList"></studentDialog>
    </div>
</template>

<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import XEUtils from 'xe-utils'
    import studentDialog from "./studentDialog";
    import * as simpleApi from "request/simple";
    import Pagination from "@/components/pagination";

    export default {
        name: 'studentList',
        data(){
            return {
                tableData: [], tableHeight:0,
                loading:true, isShow:false,
                schoolList: [], hardClassList: [],professionList: [],
                selStudent: null, selStudentDtl: null,
                searchForm:{ pageNo: 1, pageSize: 50, totalCount: 0, searchText: null, schoolId: null, hardClassId: null, professionId: null},
                jsonData: [], jsonLoading: false, jsonFields: {
                    "学号": { field: "my_no",
                        callback: value =>{
                            return "&nbsp;" + value;
                        }
                    }, "用户名": "name", "姓名": "nick_name", "所属单位": "school_name", "行政班": "hard_class_name", "入学年": "year", "专业": "profession_name",
                    "联系方式": "phone_no", "备注": "remark"
                }
            }
        },
        components:{
            studentDialog, Pagination
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            })
        },
      	mounted() {
            this.loadSchoolList();
            this.loadHardClassIdList();
            this.loadProfessionList();
            this.loadStudentList();
	   },
        methods: {

          selectionChange(val) {
            this.selections = val;
          },
            loadStudentList(){
                this.loading = true;
                let search = { searchText: mUtils.searchText(this.searchForm.searchText), licenceId: this.userInfo.licenceId,
                    schoolId: mUtils.searchText(this.searchForm.schoolId), hardClassId: mUtils.searchText(this.searchForm.hardClassId)
                , professionId: mUtils.searchText(this.searchForm.professionId),};
                let param = { controllerName: 'sclStudent', methodName: '/list', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.tableData = data.result;
                        this.searchForm.pageNo = data.pageNo;
                        this.searchForm.pageSize = data.pageSize;
                        this.searchForm.totalCount = data.totalCount;
                    }
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    console.log("error")
                });
            },
            loadSchoolList(){

                let search = { licenceId: this.userInfo.licenceId};
                let param = { controllerName: 'school', methodName: '/list', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.schoolList = data.result;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            loadHardClassIdList(){

                let search = { licenceId: this.userInfo.licenceId};
                let param = { controllerName: 'sclHardClass', methodName: '/list', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.hardClassList = data.result;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            loadProfessionList(){

                let search = { licenceId: this.userInfo.licenceId};
                let param = { controllerName: 'sclProfession', methodName: '/list', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.professionList = data.result;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            excelOutput(){

                this.jsonLoading = true;
                let search = { searchText: mUtils.searchText(this.searchForm.searchText), licenceId: this.userInfo.licenceId,
                    schoolId: mUtils.searchText(this.searchForm.schoolId), hardClassId: mUtils.searchText(this.searchForm.hardClassId)
                    , professionId: mUtils.searchText(this.searchForm.professionId),};
                let param = { controllerName: 'sclStudent', methodName: '/list', pageNo: 1, pageSize: 50000, param: search};
                return simpleApi.listWait(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        let list = data.result;
                        this.jsonData = list;
                    }
                    this.jsonLoading = false;
                }).catch((error) => {
                    this.jsonLoading = false;
                    console.log("error")
                });
            },
            // 上下分页
            handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadStudentList()
            },
            // 每页显示多少条
            handleSizeChange(val){
                this.searchForm.pageSize = val;
                this.loadStudentList()
            },
            onDeleteStudent(row){
                let id = row.id
                let that = this;
                this.$confirm('此操作将永久删除该教师以及明细, 是否继续?', '提示', {
                    confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                }).then(() => {

                    let param = { controllerName: 'sclStudent', methodName: '/delete', param: { id: id }};
                    simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                        if (code == 0) {
                            that.$message({ type: 'success', message: '删除成功!'});
                            that.loadStudentList()
                        }
                        if (code == -3) {
                            that.$message({ type: 'error', message: '该学生下已有数据，请先清除数据后再删除！'});
                            return ;
                        }
                    });
                }).catch(() => {

                });
            },

          // delSelectionStudent(){
          //   let that = this;
          //   this.loading = true;
          //   this.$confirm(`删除${this.selections.length}个学生, 是否继续?`, '提示', {
          //     confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
          //   }).then(async () => {
          //     for (const row of this.selections) {
          //       // 在这里，你可以调用你的删除学生的 API
          //
          //       let param = {controllerName: 'sclStudent', methodName: '/delete', param: {id: row.id}};
          //       let ret = await simpleApi.post(param);
          //       console.log(ret)
          //       // ({ result: { code, data}, sysCode}
          //       // console.log(ret)
          //       if (ret.result.code === 0){
          //         that.$message({ type: 'success', message: '删除成功!'});
          //       }
          //       if (ret.result.code === -3) {
          //         that.$message({ type: 'error', message: '该学生下已有数据，请先清除数据后再删除！'});
          //         this.loading = false;
          //         break ;
          //       }
          //
          //     }
          //     await this.loadStudentList()
          //     this.loading = false;
          //
          //   }).catch(() => {
          //
          //   });
          // },
            openStudent(row){
                if(row != null){
                    this.selStudent = row;
                }else{
                    this.selStudent = { id: null, licenceId: null, myNo: null, name: null, nick_name: null, pass: null,phoneNo: null, hardClassId: null, remark: null, time: (new Date()).getMilliseconds()};
                }
                this.$refs.studentDialog.showDialog();
            },


        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

    .search_container{

    }
    .btnRight{
        float: right;
        margin-right: 0px !important;
    }
    .searchArea{
        background:rgba(255,255,255,1);
        border-radius:2px;
        padding: 18px 18px 0;
    }
    .table_container{
        padding: 10px;
        background: #fff;
        border-radius: 2px;
    }
    .el-dialog--small{
       width: 600px !important;
    }
    .pagination{
        text-align: left;
        margin-top: 10px;
    }

</style>


